"use strict";
'use es6'; // throws a warning if a `requiredByPropName` is not passed when this prop exists
// otherwise, calls the passed propType checker (e.g. PropTypes.bool)
// adapted from https://github.com/airbnb/prop-types/blob/master/src/requiredBy.js

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getRequiredBy;

function getRequiredBy(requiredByPropName, propType) {
  return function (props, propName, componentName) {
    if (props[requiredByPropName]) {
      if (typeof props[propName] === 'undefined') {
        return new TypeError(componentName + ": when " + requiredByPropName + " is defined, prop " + propName + " must also be defined");
      }
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(void 0, [props, propName, componentName].concat(rest));
  };
}

module.exports = exports.default;